import Model from '@models/Model'

import ProfileCollection from '@models/Profile/collection'
import LocaleCollection from '@models/Locale/collection'
import ServiceCollection from '@models/Service/collection'

export default class ToolbarData extends Model {
  get userId () {
    return this.$model.userId
  }

  get portalUrl () {
    return this.$model.portalUrl
  }

  get settingsUrl () {
    return this.$model.settingsUrl
  }

  get settingsPath () {
    return this.$model.settingsPath
  }

  get logoutUrl () {
    return this.$model.logoutUrl
  }

  get signUpUrl () {
    return this.$model.signUpUrl
  }

  get loginUrl () {
    return this.$model.loginUrl
  }

  get userEmail () {
    return this.$model.userEmail
  }

  getSchema () {
    return {
      'userId': {
        type: String
      },

      'portalUrl': {
        type: String
      },

      'settingsUrl': {
        type: String
      },

      'settingsPath': {
        type: String
      },

      'logoutUrl': {
        type: String
      },

      'signUpUrl': {
        type: String
      },

      'loginUrl': {
        type: String
      },

      'locales': {
        type: LocaleCollection
      },

      'profiles': {
        type: ProfileCollection
      },

      'services': {
        type: ServiceCollection
      },

      'userEmail': {
        type: String
      }
    }
  }

  fetch () {
    return super.fetch('toolbar-data')
  }
}



// WEBPACK FOOTER //
// ./src/models/ToolbarData/model.js